// extracted by mini-css-extract-plugin
module.exports = {"editor-blog-list-all":"News_editor-blog-list-all__pYAOf","eco-pagination":"News_eco-pagination__fcAUa","ef-box":"News_ef-box__BBdcx"};